export const getUniqueSeriesNames = (series) => {
  return Array.from(new Set(series.map(item => item.name)));
}

export const checkUserJwt = () => {
  
}

export const getLanguageFullName = (slug) => {
  const arrayOfLanguages = {
    'wychowanie-przedszkolne' : "Wychowanie przedszkolne",
    'jezyk-niemiecki'         : "Język niemiecki",
    'jezyk-hiszpanski'        : "Język hiszpański",
    'jezyk-rosyjski'          : "Język rosyjski",
    'jezyk-francuski'         : "Język francuski",
  }
  return arrayOfLanguages[slug];
}

export const getCategoryFullName = (slug) => {
  const arrayOfCategories = {
    'dokumentacja-nauczyciela'    : "Dokumentacja nauczyciela",
    'materialy-na-lekcje'         : "Materiały na lekcje",
    'sprawdziany-kartkowki-testy' : "Sprawdziany, kartkowki, testy",
    'materialy-dodatkowe'         : "Materiały dodatkowe",
    'karty-pracy'                 : "Karty pracy",
    'scenariusze'                 : "Scenariusze",
    'diagnoza'                    : "Diagnoza",
    'plansze'                     : "Plansze",
    'nagrania'                    : "Nagrania",
    'jezyki-obce'                 : "Języki obce",
    'dla-ukrainy'                 : "Dla Ukrainy",
    'testy-kartkowki-diagnoza'    : 'Testy, kartkówki, diagnoza',
    'dodatkowe-materialy'         : 'Dodatkowe materiały',
    'materialy-dla-uczniow-z-dysleksja' : 'Materiały dla uczniów z dysleksja', 
    'dokumentacja-szkolna'        : 'Dokumentacja szkolna',
    'materialy-do-kopiowania'     : 'Materiały do kopiowania',
    'scenariusze-lekcji'          : 'Scenariusze lekcji'
  }
  return arrayOfCategories[slug] !== undefined ? arrayOfCategories[slug] : slug;
}

export const getLanguageSeriesLevels = (slug) => {
  console.log(slug)
  const arrayOfLevels = {
    '7-8-sp' : "Szkoła podstawowa 7-8"
  }
  return arrayOfLevels[slug] !== undefined ? arrayOfLevels[slug] : slug;
}